import { useState, useEffect } from "react";
import { useMutation } from "@apollo/client";
import { UPDATE_USER_MUTATION } from "../../graphql/mutations";
import Loader from "../views/Loader";

export default function Formfield(props: any) {
  const [fieldValue, setFieldValue] = useState(props.fieldValue);
  const fieldName = props.fieldName;
  const [showField, setShowfield] = useState(false);
  const onShow = () => setShowfield(true);
  
  // Update local state when props change
  useEffect(() => {
    setFieldValue(props.fieldValue);
  }, [props.fieldValue]);

  const [onSave, { loading, error }] = useMutation(UPDATE_USER_MUTATION, {
    onCompleted: (data) => {
      if (data) {
        setShowfield(false);
      } else {
        alert(error);
      }
    },
  });

  return (
    <div className="pt-6 sm:flex">
      <dt className="font-medium text-gray-900 dark:text-gray-100 sm:w-64 sm:flex-none sm:pr-6">
        {props.fieldLabel}
      </dt>
      {showField ? (
        <dd className="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
          <div className="text-gray-900 dark:text-gray-100">
            <input
              onChange={(e) => setFieldValue(e.target.value)}
              type={props.fieldType}
              name={props.fieldName}
              id={props.fieldName}
              className="block w-full bg-white dark:bg-gray-600 rounded-md border-0 py-1.5 text-gray-900 shadow-sm dark:text-gray-100 ring-1 ring-inset ring-gray-300 dark:ring-gray-700 placeholder:text-gray-400 dark:placeholder:text-gray-600 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              placeholder={props.placeholder}
              value={fieldValue}
            />
          </div>
          {loading ? (
            <Loader />
          ) : (
            <button
              onClick={(e) => onSave({ variables: { fieldName, fieldValue } })}
              type="button"
              className="font-semibold text-indigo-600 hover:text-indigo-500 dark:text-indigo-400 dark:hover:text-indigo-300"
            >
              Save
            </button>
          )}
        </dd>
      ) : (
        <dd className="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
          <div className="text-gray-900 dark:text-gray-100">
            <div className="text-gray-900 dark:text-gray-100">
              {props.fieldValue}
            </div>
          </div>
          <button
            onClick={onShow}
            type="button"
            className="font-semibold text-indigo-600 hover:text-indigo-500 dark:text-indigo-400 dark:hover:text-indigo-300"
          >
            Edit
          </button>
        </dd>
      )}
    </div>
  );
}
